<app-patient-chart    
    [patient]="patient" 
    [hasButtonUpload]="true"
    [hasNewPatient]="true"
    (onButtonUpload)="handleImageUpload()"
    (onButtonSkip)="handleSkipStep()">
</app-patient-chart>
